export enum ProfilePageTypes {
    USER_PROFILE = "USER_PROFILE",
    LOYALTY_CARDS = "LOYALTY_CARDS",
    HELP = "HELP",
    PRIVACY_DOWNLOAD = "PRIVACY_DOWNLOAD",
    PRIVACY_DELETE = "PRIVACY_DELETE",
    ALERT_CREATOR = "ALERT_CREATOR",
    ALERT_MANAGER = "ALERT_MANAGER",
    SAVED = "SAVED",
    MY_MEDALS = "MY_MEDALS",
}
export type ProfilePages = keyof Omit<typeof ProfilePageTypes, "prototype">;
